export const FILTER_KEYS = {
    STATUS: "status",
    MIGRATION_PHASE: "migrationPhase"
} as const;

export const MIGRATION_PHASES = {
    EXPLORE: "Explore",
    ASSESS: "Assess",
    PLAN_AND_TRACK: "Plan & Track",
    TEST_MIGRATION: "Test Migration",
    PROD_MIGRATION: "Prod Migration",
    POST_MIGRATION: "Post-Migration"
} as const;

export type MigrationPhase =
    (typeof MIGRATION_PHASES)[keyof typeof MIGRATION_PHASES];

export const PRODUCT_NAMES = {
    JIRA: "JIRA",
    CONFLUENCE: "CONFLUENCE"
} as const;

export type ProductName = (typeof PRODUCT_NAMES)[keyof typeof PRODUCT_NAMES];

export const PRODUCT_VARIANTS = {
    SOURCE: "source",
    DESTINATION: "destination"
} as const;

export type ProductVariant =
    (typeof PRODUCT_VARIANTS)[keyof typeof PRODUCT_VARIANTS];

export type FilterOption<T> = {
    label: string;
    value: T;
};
